import Base from '../../../base';
import Gikam from "../../../../core/gikam-core";
import Vue from 'vue';

let defaultOptions = {
    renderTo: void 0,
    onAfterClose: Gikam.emptyFunction
}

export default class Drag extends Base {
    constructor(options) {
        super(options);
        this.initialize(options, defaultOptions).init(options);
    }

    close() {
        this.DragModal.$destroy;
        Gikam.removeDom(this.DragModal.$el);
        this.DragModal = null;
    }

    showDragModel() {
        let _this = this;
        this.DragModal = new Vue({
            el: Gikam.createDom('div', this.options.renderTo),
            components: {
                indexPanelConfig: () => import('@/gikam/js/components/huge/indexPanelConfig/vue/indexPanelConfig.vue')
            },
            methods: {
                modalClose: _this.close
            },
            data() {
                return {
                    options: _this.options
                }
            },
            template: '<indexPanelConfig :options="options" @close="modalClose"/>'
        })
    }

    init() {
        this.showDragModel();
    }
}